import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import { LoyaltyProgramGridPluginSettings } from './LoyaltyProgramPluginSettings';
import { LoyaltyProgramGrid } from './LoyaltyProgramGrid';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const LoyaltyProgramTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('service.submenu.loyaltyProgram'),
        view: {
            content: LoyaltyProgramGridPluginSettings
                ? <LoyaltyProgramGrid
                    gridId={uuidv4()}
                    plugin={LoyaltyProgramGridPluginSettings}
                />
                : <p> Справочник не настроен</p>
        }
    }
}